export const PROJECT_ID = "d6ac65de-60c1-0125-ddbc-abf411cfd63c";
export * from "./theme";
